import { render } from "./CrStepSurface4Content.vue?vue&type=template&id=1aeae0f8&scoped=true"
import script from "./CrStepSurface4Content.vue?vue&type=script&lang=js"
export * from "./CrStepSurface4Content.vue?vue&type=script&lang=js"

import "./CrStepSurface4Content.vue?vue&type=style&index=0&id=1aeae0f8&scoped=true&lang=scss"

import exportComponent from "/home/forge/pga-beta.devserver6.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aeae0f8"]])

export default __exports__